import {
  REGISTER_VERIFY,
  REGISTER_VERIFY_SUCCESS,
  REGISTER_VERIFY_FAILURE,
} from 'store/registerVerify/registerVeifyAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const registerVerifyReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_VERIFY:
      return { ...state, loading: true };
    case REGISTER_VERIFY_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case REGISTER_VERIFY_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default registerVerifyReducer;
